import { ICrisisStore } from './types';

const initStore: ICrisisStore = {
  current: null,
  allocatedClients: [],
  crisisCalls: [],
  crisisCallTeamMembers: [],
};

export default initStore;
